import { DetailedHTMLProps, PropsWithChildren, HTMLAttributes } from 'react'

interface CardTitleProps extends DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> {
    children: PropsWithChildren['children']
}

export default function CardTitle({ children, className, ...props }: CardTitleProps) {
    return <h3 className={'card-title' + (className ? ` ${className}` : '')} {...props}>{children}</h3>
}
